import { render } from "./SkyModal.vue?vue&type=template&id=161797b4&scoped=true"
import script from "./SkyModal.vue?vue&type=script&lang=js"
export * from "./SkyModal.vue?vue&type=script&lang=js"

import "./SkyModal.vue?vue&type=style&index=0&id=161797b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161797b4"]])

export default __exports__